import * as React from 'react';
import { observer } from 'mobx-react';

import { CheckBox, RadioButton } from 'common--design-library';
import * as classNames from 'classnames';
import { AMLWidgetTypeUI } from 'eTip--common';

interface IAMLItemProps {
    id: number;
    label: string;
    widgetType: AMLWidgetTypeUI;
    textAtEnd: string | null;
    isSelected: boolean;
    subItemText: IAMLItemText;
    subItem1OfN: IAML1OfN;
    isDisabled: boolean;
    setSelected: (subItemId?: number) => void;
}

interface IAMLItemText {
    label: string;
    content: string;
    contentChanged: (newValue: string) => void;
}

interface IAML1OfN {
    items: IAML1OfNItem[];
    selectedId: number;
    setSelected: (id: number) => void;
}

interface IAML1OfNItem {
    id: number;
    label: string;
}

export interface IAMLOptionsComponentProps {
    items: IAMLItemProps[];
    toggleOption: (id: number) => void;
    removeMargins?: boolean;
    updateDisabled: () => void; // call after every change in items
}

export const AMLOptionsComponent: React.FC<IAMLOptionsComponentProps> = observer((props: IAMLOptionsComponentProps) => {
    return props.items && props.items.length
        ? <div className={classNames("saved-ticket aml", props.removeMargins && "m-0")}>
            <div className="content">
                <p>
                    Zavazuji se informovat společnost SYNOT TIP, a.s. o změně svého statusu politicky exponované osoby, pokud k ní dojde v době trvání obchodního vztahu.
                </p>
                <p>

                </p>
                {

                    props.items.map((item) =>
                        <React.Fragment key={item.id}>
                            {
                                item.widgetType == AMLWidgetTypeUI.Default
                                    ? <CheckBox
                                        onChangehandler={() => { if (item.isDisabled) { return; } props.toggleOption(item.id); }}
                                        isChecked={item.isSelected}
                                        verticalPosition="top"
                                        isDisabled={item.isDisabled}
                                    >
                                        <span>{item.label}</span>


                                        {item.subItemText &&
                                            <>&nbsp; <input type="text"
                                                value={item.subItemText.content}
                                                onChange={(evt) => { if (item.isDisabled) { return; } item.subItemText.contentChanged(evt.target.value); item.setSelected(); props.updateDisabled(); }}
                                                onClick={(e) => { e.stopPropagation(); }}
                                                className="aml-subtext"
                                            /></>}

                                        {item.subItem1OfN && <>
                                            {item.subItem1OfN.items.map(subItem => {
                                                const splitLabel = subItem.label.split("**");
                                                return <RadioButton
                                                    key={subItem.id}
                                                    isChecked={subItem.id === item.subItem1OfN.selectedId}
                                                    onChangehandler={() => { item.setSelected(subItem.id); props.updateDisabled(); }}
                                                    verticalPosition="top"
                                                    onClickBeforeChange={(evt) => { evt.stopPropagation(); }}
                                                    isDisabled={item.isDisabled}
                                                >{splitLabel.length == 3 /* expecting one pair of **, can use cycle for % 3 == 0 */
                                                    ?
                                                    <>
                                                        {splitLabel[0]}
                                                        <b>{splitLabel[1]}</b>
                                                        {splitLabel[2]}
                                                    </>
                                                    : <span dangerouslySetInnerHTML={{ __html: subItem.label }} ></span>
                                                    }
                                                </RadioButton>
                                            })}
                                        </>}
                                        {item.textAtEnd && <div className="ml-2">{item.textAtEnd}</div>}
                                    </CheckBox>
                                    :
                                    (
                                        item.widgetType == AMLWidgetTypeUI.Select && item.subItem1OfN
                                            ?
                                            <div className="pt-3">
                                                <div>{item.label}</div>
                                                <select disabled={item.isDisabled} onChange={(e) => { item.setSelected(Number(e.target.value)); props.updateDisabled(); }} value={item.subItem1OfN.selectedId} >
                                                    {
                                                        item.subItem1OfN.items.map(subItem =>
                                                            <option
                                                                key={subItem.id}
                                                                value={subItem.id}>{subItem.label}
                                                            </option>)
                                                    }
                                                </select>
                                            </div>
                                            :
                                            (item.widgetType == AMLWidgetTypeUI.Label && <p className="pt-3">{item.label}</p>)
                                    )
                            }
                        </React.Fragment>
                    )
                }
            </div>
        </div >
        : null
})